import gql from 'graphql-tag';

import { CHANGE_EVENT_ANSWER_FRAGMENT } from '../Answer/changeEventAnswer';
import { FULL_PLEX_USER_RELATION_FRAGMENT } from '../PlexUserRelation/fullPlexUserRelation';

export const CHANGE_EVENT_QUESTION_OVERVIEW_FRAGMENT = gql`
  fragment changeEventQuestionOverview on Question {
    id
    permalink
    text
    status
    plex {
      id
      name
      color
      currentUserRelation {
        ...fullPlexUserRelation
      }
    }
    acceptedAnswer {
      ...changeEventAnswer
    }
    deleted
    createdAt
    publishChangedAt
    author {
      id
      name
      email
      picture
      jobTitle
    }
    labels {
      id
      name
    }

    currentUserRelation
    watching
    boardId
  }

  ${CHANGE_EVENT_ANSWER_FRAGMENT}
  ${FULL_PLEX_USER_RELATION_FRAGMENT}
`;
